'use strict';

const { h } = require('phy');

const Header = require('../../shared/views/header');
const RedemptionProvider = require('../../redemption/views/redemption-provider-hoc');

const Breadcrumbs = require('../../../components/breadcrumbs');
const LeaderboardBannerWrapper = require('../../../components/leaderboard_banner');
const MainContent = require('./category-main-content');
const SideBar = require('./category-sidebar');
const Footer = require('../../../components/footer');

const { pruneData } = require('../../support/prune-data');

function getElements({
  isTouch,
  advertsForCarousel,
  routes,
  categoryId,
  csrfToken,
  categoryMerchants,
  relatedCategories,
  relatedMerchants,
  leaderboardAdverts,
  couponsForList,
  premiumOffers,
}) {
  const leaderboardBanner = LeaderboardBannerWrapper({
    adverts: leaderboardAdverts,
    isTouch,
    outerClassName: 'category-offers-section',
    routes: pruneData(routes, 'merchant:show'),
  });
  const mainContentElement = MainContent({
    premiumOffers,
    couponsForList,
    routes,
    isTouch,
    categoryId,
    relatedCategories,
    relatedMerchants,
    leaderboardBanner,
  });
  const sidebarElement = SideBar({
    advertsForCarousel,
    routes,
    categoryId,
    isTouch,
    leaderboardBanner,
    csrfToken,
    categoryMerchants,
  });

  if (isTouch) {
    return [h('.twelve.column', [mainContentElement, sidebarElement])];
  }

  return [
    h('.nine.column.push-three', mainContentElement),
    h('.three.column.pull-nine', sidebarElement),
  ];
}

function CategoryOffers({ payload, deps }) {
  const {
    seoMetaData: { h1Override },
    navigationMerchants,
    categoryId,
    premiumOffers,
    couponsForList,
    categoryMerchants,
    advertsForCarousel,
    leaderboardAdverts,
    relatedMerchants,
    relatedCategories,
  } = payload;
  const { routes, csrfToken, isTouch, breadcrumbList } = deps;

  return h('article.wrapper-page', [
    h(RedemptionProvider, { routes }),
    h(Header, {
      routes,
      merchants: navigationMerchants,
      titleText: h1Override,
      resourceKey: `modules.category.Name.${categoryId}`,
    }),
    h(
      'section.page-container',
      h(
        '.row',
        ...getElements({
          isTouch,
          advertsForCarousel,
          routes,
          categoryId,
          csrfToken,
          categoryMerchants,
          premiumOffers,
          couponsForList,
          relatedCategories,
          relatedMerchants,
          leaderboardAdverts,
        })
      ),
      h('.row', h('.twelve.column', Breadcrumbs(breadcrumbList), Footer()))
    ),
  ]);
}

module.exports = CategoryOffers;
